import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CssBaseline } from '@mui/material';
import { theme } from 'assets/theme';
import Snackbar from 'components/Snackbar';
import Stars from 'components/Stars/Stars';
import Providers from 'providers';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from 'routes';
const App = () => {
    return (_jsxs(Providers, { options: { appName: '' }, theme: theme, children: [_jsx(CssBaseline, {}), _jsx(Stars, {}), _jsx(Snackbar, {}), _jsx(BrowserRouter, { future: { v7_relativeSplatPath: true, v7_startTransition: true }, children: _jsx(AppRoutes, {}) })] }));
};
export default App;
